import { render, staticRenderFns } from "./MetamaskSettings.vue?vue&type=template&id=b28661ca&"
import script from "./MetamaskSettings.vue?vue&type=script&lang=js&"
export * from "./MetamaskSettings.vue?vue&type=script&lang=js&"
import style0 from "./MetamaskSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports